import styled from '@emotion/styled'
import { keyframes } from '@emotion/react'
import { colors } from '../colors'

const shimmer = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`

export const SkeletonBase = styled.div`
  display: inline-block;
  background: linear-gradient(
    90deg,
    ${colors.gray200} 25%,
    ${colors.gray100} 50%,
    ${colors.gray200} 75%
  );
  background-size: 200% 100%;
  animation: ${shimmer} 1.4s ease-in-out infinite;
`
